import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ConfirmDialogData {
  header: string; // Titulo de cabecera
  message: string; // Mensaje de confirmación
  icon?: string; // Icono del mensaje
  acceptLabel?: string; // Texto del boton de confirmar
  rejectLabel?: string; // Texto del botón de cancelar
  acceptButtonStyleClass?: string; // Texto de clases CSS de botón confirmar
  rejectButtonStyleClass?: string; // Texto de clases CSS del botón cancelar
  onAccept?: (inputValue?: string) => Promise<void>; // Función al dar clic en botón confirmar
  onReject?: () => Promise<void>; // Función en caso de cerrar o dar clic en botón cancelar
  requireInput?: boolean; // True indica que se renderiza el input
  inputLabel?: string; // Label del input
  inputPlaceholder?: string; // Placeholder del input
  inputRequired?: boolean; // True indica que el input es obligatorio
}

@Injectable({
  providedIn: 'root',
})
export class ConfirmDialogService {
  private confirmSubject = new Subject<ConfirmDialogData>();
  public confirm$ = this.confirmSubject.asObservable();

  confirm(data: ConfirmDialogData): void {
    this.confirmSubject.next(data);
  }
}
